import React, { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import useEdd from "../hooks/useEdd";
import FormSection from "../components/FormSection/FormSection";
import Loader from "../components/ui/Loader/Loader";

const EddForm: React.FC = () => {
  const [openAccordionId, setOpenAccordionId] = useState<number>(0);
  const [enabledSectionsCount, setEnabledSectionsCount] = useState<number>(0);
  const [enableSubmitButton, setEnableSubmitButton] = useState<boolean>(false);
  const [isSendingEddData, setIsSendingEddData] = useState<boolean>(false);
  const [uploadedDocuments, setUploadedDocuments] = useState<any[]>([]);
  const [isAuthTokenSet, setIsAuthTokenSet] = useState<boolean | undefined>(
    false
  );
  const [isSubmittingEddData, setIsSubmittingEddData] =
    useState<boolean>(false);

  const {
    data: eddFormData,
    refresh: refreshEddFormData,
    isFetching: isFetchingEddFormData,
  }: { data: any; refresh: () => void; isFetching: boolean } = useEdd({
    dependencyCondition: isAuthTokenSet,
    dependencyList: [isAuthTokenSet],
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (window?.authToken) {
        sessionStorage.setItem("authToken", window?.authToken ?? "");
        setIsAuthTokenSet(true);
      }
    }, 100);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const firstPendingSectionId = eddFormData?.sections?.findIndex(
      (section: any) => section?.status === "PENDING"
    );
    if (!isNaN(firstPendingSectionId)) {
      setEnabledSectionsCount(
        Math.max(firstPendingSectionId + 1, enabledSectionsCount)
      );
      setOpenAccordionId(firstPendingSectionId);
    }
  }, [JSON.stringify(eddFormData)]);

  return (
    <div className="p-4 max-w-md mx-auto">
      <Header isSubmittingEddData={isSubmittingEddData} />
      <div className="mt-14 mb-40">
        {isFetchingEddFormData ? (
          <div className="flex items-center justify-center  h-[75vh]">
            <Loader color="purple" />
          </div>
        ) : (
          eddFormData?.sections?.map((section: any, index: number) => (
            <FormSection
              section={section}
              openAccordionId={openAccordionId}
              setOpenAccordionId={setOpenAccordionId}
              id={index}
              enabledSectionsCount={enabledSectionsCount}
              setEnabledSectionsCount={setEnabledSectionsCount}
              refreshEddFormData={refreshEddFormData}
              setEnableSubmitButton={setEnableSubmitButton}
              isSendingEddData={isSendingEddData}
              setIsSendingEddData={setIsSendingEddData}
              uploadedDocuments={uploadedDocuments}
              setUploadedDocuments={setUploadedDocuments}
            />
          ))
        )}
      </div>
      <Footer
        enableSubmitButton={enableSubmitButton}
        uploadedDocuments={uploadedDocuments}
        setUploadedDocuments={setUploadedDocuments}
        enabledSectionsCount={enabledSectionsCount}
        isSendingEddData={isSendingEddData}
        formProgress={eddFormData?.progress}
        isSubmittingEddData={isSubmittingEddData}
        setIsSubmittingEddData={setIsSubmittingEddData}
      />
    </div>
  );
};

export default EddForm;
